/**
 * API Path Constants
 * All backend endpoint paths used across BFL applications
 */

export const API_PATHS = {
  // Authentication & Authorization
  sendOtp: "/api/v2/login-oauth-otp",
  verifyOtp: "/api/v1/login-oauth-token",
  logout: "/api/v1/logout",
  verifyToken: "/api/v1/oauth-token-verify",
  verifySsoToken: "/api/v1/login-oauth-sso-token-verify",
  centralLogin: "/api/v1/central-login",
  federatedLogin: "/api/v1/federated-login",
  federatedAuthorize: "/api/v1/federated-authorize",
  federatedBflWebLogin: "/api/v1/federated/bflweb-login",
  federatedBflWebAuthorize: "/api/v1/federated/bflweb-authorize",

  // User Management
  userDetails: "/api/v1/user/details",
  relationships: "/api/v2/user/relationships",

  // iCORS (Pre-qualified offers)
  icors: "/api/v1/icors",

  // Cart Operations
  cartRead: "/api/v1/cart/read",
  cmsCartProducts: "/api/v1/cart/cmscartproducts",

  // Home Loans
  hlInsert: "/api/v1/hl/insert",
  hlRead: "/api/v1/hl/read",
  hlCalculator: "/api/v1/hl/calculator",

  // Personal Loans
  plInsert: "/api/v1/pl/insert",
  plRead: "/api/v1/pl/read",
  pleCalculator: "/api/v1/ple/calculator",

  // Gold Loans
  glInsert: "/api/v1/gl/insert",
  glRead: "/api/v1/gl/read",
  glCalculator: "/api/v1/gl/calculator",
  goldLoanDetails: "/api/v1/gl/details",
  goldRateChart: "/api/v1/gl/rate-chart",

  // Business Loans (LAP, LAS, BL)
  lapInsert: "/api/v1/lap/insert",
  lasInsert: "/api/v1/las/insert",
  blInsert: "/api/v1/bl/insert",

  // Loan Summary & Cross-sell
  loansRead: "/api/v1/loans/read",
  loanSummary: "/api/v1/loans/summary",
  loanSummaryCharge: "/api/v1/loans/b2c/charge-calculation",
  crossSellSme: "/api/v1/loans/sme/products",
  crossSellB2C: "/api/v1/loans/b2c/products",
  crossSellB2CStatic: "/api/v1/loans/b2c/static-products",
  doacValidate: "/api/v1/loans/b2c/details",

  // Insurance
  balicInsert: "/api/v1/balic/insert-and-generate-link",
  balicRead: "/api/v1/balic/read",
  laipInsert: "/api/v1/laip/insert",
  termInsuranceMiniForm: "/api/v1/term-insurance/mini-form",
  iefInsert: "/api/v1/ief/insert",
  mefInsert: "/api/v1/mef/insert",
  mflInsert: "/api/v1/mfl/insert",
  tfInsert: "/api/v1/tf/insert",
  twfInsert: "/api/v1/twf/insert",
  profInsert: "/api/v1/prof/insert",
  insurancePlans: "/api/v1/insurance/plans",
  networkHospital: "/api/v1/insurance/network-hospitals",

  // Credit Cards
  ccRead: "/api/v1/cc/read",
  ccSegmentMaster: "/api/v1/cc/segmentmaster",
  ccInsertCard: "/api/v1/cc/insert",
  ccDetails: "/api/v1/cc/details",
  cardAPI: "/api/v1/card",

  // Fixed Deposits
  fdCorporate: "/api/v1/fd/corporate",
  fdSdp: "/api/v1/fd/sdp",
  cdInsert: "/api/v1/cd/insert",
  cdRead: "/api/v1/cd/read",

  // Trading & Investments
  mtf: "/api/v1/trading/get-MTFList",
  ncd: "/api/v1/trading/get-NCDList",
  ipoList: "/api/v1/trading/ipo-list",
  allStocks: "/api/v1/trading/all-stocks",
  stockList: "/api/v1/trading/stock-list",
  stocksForYou: "/api/v1/trading/stocks-for-you",
  stockFundamentals: "/api/v1/trading/stock-fundamentals",
  stockStatistics: "/api/v1/trading/stock-statistics",
  mtfStock: "/api/v1/trading/mtf-stock",
  scripFinancials: "/api/v1/trading/scrip-financials",
  scripPerformanceGraph: "/api/v1/trading/scrip-performance",
  scripShareholdingPattern: "/api/v1/trading/scrip-shareholding",
  scripSimilarStocks: "/api/v1/trading/scrip-similar-stocks",
  getTechnicalsSummary: "/api/v1/trading/technicals-summary",
  indices: "/api/v1/trading/indices",
  mutualFunds: "/api/v1/trading/mutual-funds",
  portfolio: "/api/v1/trading/portfolio",
  watchList: "/api/v1/trading/watchlist",
  brokerApi: "/api/v1/trading/broker",
  corporateActions: "/api/v1/trading/corporate-actions",
  aboutCompany: "/api/v1/trading/about-company",

  // Catalogue & Search
  filters: "/api/v1/catalogue/filters",
  filterResults: "/api/v1/catalogue/results",
  skuDetails: "/api/v1/catalogue",
  skuByCard: "/api/v1/catalogue/sku-by-card",
  recommended: "/api/v1/catalogue/recommended",
  twoWheelerSearch: "/api/v1/two-wheeler/search",
  exploreTopProducts: "/api/v1/catalogue/explore-top-products",
  getProductByPincode: "/api/v1/master/pincode",
  productRequirementGST: "/api/v1/catalogue/product-requirement-gst",
  inPageSearch: "/api/v1/search/in-page",
  searchApi: "/api/v1/search",
  dynamicFilter: "/api/v1/catalogue/dynamic-filter",

  // Content & Bannerization
  bannerizationDynamic: "/api/v1/dynamic/get-banners",
  dynamicViews: "/api/v1/dynamic/views",
  dynamicIcon: "/api/v1/dynamic/icon",
  urlModuleMapping: "/api/v1/master/url-module-mapping",
  cityScrollableTable: "/api/v1/master/city-scrollable-table",
  featureManagement: "/api/v1/master/feature-management",

  // News & Content
  news: "/api/v1/content/news",
  newsFeed: "/api/v1/content/news-feed",
  articleAndInsights: "/api/v1/content/article-insights",
  investopedia: "/api/v1/content/investopedia",
  learningCenter: "/api/v1/content/learning-center",
  getFilterVideos: "/api/v1/content/filter-videos",
  getRelatedVideos: "/api/v1/content/related-videos",
  videoViews: "/api/v1/content/video-views",

  // Utilities
  stamping: "/api/v2/offers/owb-capture-interest",
  getACallBack: "/api/v1/callback",
  talkToLoanExpert: "/api/v1/callback/loan-expert",
  callnow: "/api/v1/callback/call-now",
  dncStatus: "/api/v1/checkDNCStatus",
  branchDetails: "/api/v1/master/branch-details",
  checkCPSubscription: "/api/v1/subscription/check",
  consentLogin: "/api/v1/consent/login",
  demog: "/api/v1/demog",
  verifyDetails: "/api/v1/verify/details",
  autofetchDetails: "/api/v1/autofetch/details",
  otpVRetry: "/api/v1/otp/retry",
  personalDetailsForm: "/api/v1/form/personal-details",
  genericInsert: "/api/v1/generic/insert",
  leadsApi: "/api/v1/leads",
  readMyOrder: "/api/v1/order/read",
  reminder: "/api/v1/reminder",
  namingCard: "/api/v1/naming-card",

  // FPR (Fixed Price Rewards)
  fprPaymentStatus: "/api/v1/fpr/payment-status",
  fprSubscription: "/api/v1/fpr/subscription",

  // Rewards & Gamification
  rewardsPoints: "/api/v1/rewards/points",
  qrRewards: "/api/v1/rewards/qr",
  makeAWish: "/api/v1/rewards/make-a-wish",
  cricketUpdate: "/api/v1/gamification/cricket-update",

  // Microsite & Special Features
  microsite: "/api/v1/microsite",
  astrology: "/api/v1/astrology",
  bfslLogin: "/api/v1/bfsl/login",
  bajajUpi: "/api/v1/bajaj-upi",
  b2cRoi: "/api/v1/b2c/roi",

  // CSRF Token
  csrf: "/api/v1/csrf",

  // Additional API paths from service migration
  aboutScript: "/api/v1/about-script",
  bfslOtpSend: "/api/v1/bfsl-otp-send",
  bfslOtpVerify: "/api/v1/bfsl-otp-verify",
  blgInsert: "/api/v1/blg-insert",
  blOfferCheck: "/api/v1/bl-offer-check",
  blOfferValidation: "/api/v1/bl-offer-validation",
  blpGetLeadDetails: "/api/v1/blp-get-lead-details",
  blpInsert: "/api/v1/blp-insert",
  blpResendOtp: "/api/v1/blp-resend-otp",
  blpSendOtp: "/api/v1/blp-send-otp",
  blpVerifyOtp: "/api/v1/blp-verify-otp",
  blseInsert: "/api/v1/blse-insert",
  blseSendOtp: "/api/v1/blse-send-otp",
  blseVerifyOtp: "/api/v1/blse-verify-otp",
  carInsuranceRedirection: "/api/v1/car-insurance-redirection",
  careerInsert: "/api/v1/career-insert",
  cityList: "/api/v1/city-list",
  cmsContentParser: "/api/v1/cms-content-parser",
  createWatchListItem: "/api/v1/create-watch-list-item",
  deleteWatchListItem: "/api/v1/delete-watch-list-item",
  eiaCheck: "/api/v1/eia-check",
  emailSend: "/api/v1/email-send",
  ezypayCreatePayment: "/api/v1/ezypay-create-payment",
  faqSearchSuggest: "/api/v1/faq-search-suggest",
  fdComparatorGetOffers: "/api/v1/fd-comparator-get-offers",
  fetchAboutUsCount: "/api/v1/fetch-about-us-count",
  fetchBajajCapitalFdRates: "/api/v1/fetch-bajaj-capital-fd-rates",
  fetchDocuments: "/api/v1/fetch-documents",
  fetchFaqCategory: "/api/v1/fetch-faq-category",
  fetchFaqlist: "/api/v1/fetch-faqlist",
  fetchInsurance: "/api/v1/fetch-insurance",
  fetchLoanEligibility: "/api/v1/fetch-loan-eligibility",
  fetchLocatorBranch: "/api/v1/fetch-locator-branch",
  fetchMediaList: "/api/v1/fetch-media-list",
  fetchNavigationData: "/api/v1/fetch-navigation-data",
  fetchPincodeDetails: "/api/v1/fetch-pincode-details",
  fetchProductContentSummary: "/api/v1/fetch-product-content-summary",
  fetchRatingsReviews: "/api/v1/fetch-ratings-reviews",
  fetchSecureDocsMetadata: "/api/v1/fetch-secure-docs-metadata",
  fetchTenure: "/api/v1/fetch-tenure",
  fetchUserRatingsReviews: "/api/v1/fetch-user-ratings-reviews",
  fetchWatchList: "/api/v1/fetch-watch-list",
  flexi: "/api/v1/flexi",
  flexiLoanCalculator: "/api/v1/flexi-loan-calculator",
  fprDataEncrypt: "/api/v1/fpr-data-encrypt",
  fprPayment: "/api/v1/fpr-payment",
  fprSubscriptionCreate: "/api/v1/fpr-subscription-create",
  fprSubscriptionVerify: "/api/v1/fpr-subscription-verify",
  getAboutUsData: "/api/v1/get-about-us-data",
  getCarInsuranceQuote: "/api/v1/get-car-insurance-quote",
  getCustomerSearchData: "/api/v1/get-customer-search-data",
  getFooterMenu: "/api/v1/get-footer-menu",
  getPartialCalculation: "/api/v1/get-partial-calculation",
  getPartnerLocations: "/api/v1/get-partner-locations",
  glEligibility: "/api/v1/gl-eligibility",
  gtmPushData: "/api/v1/gtm-push-data",
  hlEligibility: "/api/v1/hl-eligibility",
  homeInsuranceRedirection: "/api/v1/home-insurance-redirection",
  iconPosition: "/api/v1/icon-position",
  instantPaymentGetPaymentStatus: "/api/v1/instant-payment-get-payment-status",
  instantPaymentInitiate: "/api/v1/instant-payment-initiate",
  lifeInsuranceRedirection: "/api/v1/life-insurance-redirection",
  loanSummaryApiGetCalEmi: "/api/v1/loan-summary-api-get-cal-emi",
  loanSummaryApiGetIcorsDetails: "/api/v1/loan-summary-api-get-icors-details",
  plCalculator: "/api/v1/pl-calculator",
  postRatingReview: "/api/v1/post-rating-review",
  registerGuestUser: "/api/v1/register-guest-user",
  saveNegativeRating: "/api/v1/save-negative-rating",
  searchWithBranchProductNearby: "/api/v1/search-with-branch-product-nearby",
  twoWheelerInsuranceRedirection: "/api/v1/two-wheeler-insurance-redirection",
  updateWatchListItem: "/api/v1/update-watch-list-item",
  watchListUpdateItemStatus: "/api/v1/watch-list-update-item-status",

  // Additional API paths from service migration (batch 2)
  bfslSaveLead: "/api/v1/bfsl-save-lead",
  blockDeals: "/api/v1/block-deals",
  brokerdetails: "/api/v1/brokerdetails",
  callNow: "/api/v1/call-now",
  cartDelete: "/api/v1/cart-delete",
  chapterProgressInsertLc: "/api/v1/chapter-progress-insert-lc",
  consentInsert: "/api/v1/consent-insert",
  consentInsertv2: "/api/v1/consent-insertv2",
  consentRead: "/api/v1/consent-read",
  corporateAction: "/api/v1/corporate-action",
  dynamicFilters: "/api/v1/dynamic-filters",
  dynamicNudges: "/api/v1/dynamic-nudges",
  fdcorporateroifetch: "/api/v1/fdcorporateroifetch",
  fdsdpDetails: "/api/v1/fdsdp-details",
  fdsdpInsert: "/api/v1/fdsdp-insert",
  fetchAllETFs: "/api/v1/fetch-all-et-fs",
  fetchAllMarketsTodayStock: "/api/v1/fetch-all-markets-today-stock",
  fetchAllStocks: "/api/v1/fetch-all-stocks",
  fetchBrokerId: "/api/v1/fetch-broker-id",
  getChartDataScript: "/api/v1/get-chart-data-script",
  getHoldings: "/api/v1/get-holdings",
  getQuizProgress: "/api/v1/get-quiz-progress",
  getTechnicalInfo: "/api/v1/get-technical-info",
  getWatchList: "/api/v1/get-watch-list",
  glInsertAPi: "/api/v1/gl-insert-a-pi",
  globalIndices: "/api/v1/global-indices",
  glread: "/api/v1/glread",
  goldRate: "/api/v1/gold-rate",
  goldRateCities: "/api/v1/gold-rate-cities",
  goldRateCity: "/api/v1/gold-rate-city",
  goldRateList: "/api/v1/gold-rate-list",
  gstCompanyDetails: "/api/v1/gst-company-details",
  hospitalCities: "/api/v1/hospital-cities",
  hospitalList: "/api/v1/hospital-list",
  hospitalProviders: "/api/v1/hospital-providers",
  hsnDetails: "/api/v1/hsn-details",
  inPageSearchApi: "/api/v1/in-page-search-api",
  indicesData: "/api/v1/indices-data",
  insertQuizProgressLC: "/api/v1/insert-quiz-progress-lc",
  investopediaCategories: "/api/v1/investopedia-categories",
  investopediaFilters: "/api/v1/investopedia-filters",
  investopediaResults: "/api/v1/investopedia-results",
  latestfdsdpDetails: "/api/v1/latestfdsdp-details",
  leads: "/api/v1/leads",
  marketMovers: "/api/v1/market-movers",
  masterBroker: "/api/v1/master-broker",
  mutualFund: "/api/v1/mutual-fund",
  newFeedArticles: "/api/v1/new-feed-articles",
  piiIndicesData: "/api/v1/pii-indices-data",
  pimcoreIcons: "/api/v1/pimcore-icons",
  plcsInsert: "/api/v1/plcs-insert",
  pleMaster: "/api/v1/ple-master",
  qrDealer: "/api/v1/qr-dealer",
  qrUrbanRuralAPI: "/api/v1/qr-urban-rural-api",
  relatedVideos: "/api/v1/related-videos",
  reminders: "/api/v1/reminders",
  renameWatchList: "/api/v1/rename-watch-list",
  salplInsert: "/api/v1/salpl-insert",
  savePIIIndicesData: "/api/v1/save-pii-indices-data",
  scripDetails: "/api/v1/scrip-details",
  scripOverviewInfo: "/api/v1/scrip-overview-info",
  sectorStocks: "/api/v1/sector-stocks",
  stockFundaments: "/api/v1/stock-fundaments",
  stocksFilterList: "/api/v1/stocks-filter-list",
  subscriptionDetails: "/api/v1/subscription-details",
  termInsuranceMiniFormInsert: "/api/v1/term-insurance-mini-form-insert",
  updateWatchList: "/api/v1/update-watch-list",
  userProgressData: "/api/v1/user-progress-data",
  vpaLookup: "/api/v1/vpa-lookup",
} as const;

export type ApiPathKeys = keyof typeof API_PATHS;

/**
 * API Domain Configuration
 * Should be set from environment or runtime configuration
 */
export let API_Domain = process.env.NEXT_PUBLIC_WEB_SERVICES_DOMAIN;

/**
 * Set API Domain
 * Call this function to configure the base API URL
 */
export const setAPIDomain = (domain: string): void => {
  API_Domain = domain;
};

/**
 * Get API Domain
 * Returns the configured API domain
 */
export const getAPIDomain = (): string => {
  return API_Domain || "";
};

/**
 * CSRF Token Time Limit (in milliseconds)
 * Time after which CSRF token expires
 */
export const CSRFTokenTimeLimit = 24 * 60 * 60 * 1000; // 24 hours

/**
 * Default Request Timeout (in milliseconds)
 */
export const DEFAULT_TIMEOUT = 30000; // 30 seconds

/**
 * Max Retry Attempts
 */
export const MAX_RETRIES = 3;

/**
 * Retry Delay (in milliseconds)
 */
export const RETRY_DELAY = 1000; // 1 second
